import { usePrePopulateSponsorshipVoucherFlow } from 'modules/auth/flows/usePrePopulateSponsorshipVoucherFlow'
import { SignupFormData } from 'modules/auth/hooks/useSignupForm'
import { EnumAuthTrackingEvents } from 'modules/auth/lib/tracking/events'
import { useSignupStoreError } from 'modules/auth/store/useSignupStore'
import { EnumSignupErrors } from 'modules/auth/types/signup'
import { TextField } from 'modules/common/components/_ui/FormControl/TextField/TextField'
import { Message } from 'modules/common/components/_ui/Message/Message'
import { useTrackDirtyField } from 'modules/common/hooks/useTrackDirtyField'
import { useTrackOnMount } from 'modules/common/hooks/useTrackOnMount'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { Trans } from 'next-i18next'
import { useFormContext } from 'react-hook-form'
import { SignupFormActions } from './SignupFormActions'
import { SignupFormSponsorship } from './SignupFormSponsorship/SignupFormSponsorship'

export const SignupFormEmail = () => {
  const { t } = useTranslation(['auth-components', 'common'])
  const signupError = useSignupStoreError()

  const {
    register,
    watch,
    formState: { isSubmitSuccessful, errors, isSubmitting, touchedFields },
  } = useFormContext<SignupFormData>()

  useTrackDirtyField<SignupFormData>({
    name: 'email',
    event: EnumAuthTrackingEvents.SIGNUP_EMAIL_FORM_STARTED,
  })
  useTrackOnMount({
    eventType: EnumAuthTrackingEvents.SIGNUP_EMAIL_FORM_ENTER,
  })

  const { isPrePopulateSponsorshipVoucherLoading } =
    usePrePopulateSponsorshipVoucherFlow()

  const value = watch('email')
  const isNextButtonDisabled =
    !value || !!errors.email || isPrePopulateSponsorshipVoucherLoading

  return (
    <div className="flex flex-col space-y-6 lg:w-124">
      <Trans parent="h2" className="md:text-3xl">
        {t('signupForm.email.title')}
      </Trans>
      <Message content={t('signupForm.email.notification')} withIcon />
      <TextField
        label={t('signupForm.email.label')}
        error={touchedFields.email ? errors.email : undefined}
        autoFocus
        type="email"
        isRequired
        data-amp-mask=""
        {...register('email')}
      />
      {isSubmitSuccessful &&
        signupError === EnumSignupErrors.ACCOUNT_ALREADY_EXISTS && (
          <Message
            title={t('signupForm.errors.accountAlreadyExists.title')}
            content={t('signupForm.errors.accountAlreadyExists.content')}
            type="error"
          />
        )}
      <SignupFormSponsorship
        isPrePopulateSponsorshipVoucherLoading={
          isPrePopulateSponsorshipVoucherLoading
        }
      />
      <SignupFormActions
        event={EnumAuthTrackingEvents.SIGNUP_EMAIL_FORM_VALIDATED}
        isNextButtonLoading={isSubmitting}
        isNextButtonDisabled={isNextButtonDisabled}
        nextButtonLabel={t('signupForm.email.submit')}
      />
    </div>
  )
}
